import { createContext } from 'react';

const PropertyRefreshContext = createContext();

export default PropertyRefreshContext;
